import React, { useState } from "react";
import linkedInIcon from "../../assets/About/linkedInicon.svg";
import arrow from "../../assets/About/Arrow.svg";
import tag from "../../assets/About/Tag12.svg";
import Boot41Banner from "../CareerPage/Boot41Banner";

const anshuman = "https://storage.googleapis.com/think41-web-new/assets/About/ansu12.png"
const harshit = "https://storage.googleapis.com/think41-web-new/assets/About/harshit.svg";
const himanshu = "https://storage.googleapis.com/think41-web-new/assets/About/3.svg";
const sri = "https://storage.googleapis.com/think41-web-new/assets/About/4.svg";

const leadersData = [
  {
    image: anshuman,
    name: "Anshuman Singh",
    about:
      "Anshu loves tech and scalability, having built hundreds of products and driven significant growth  in the past 13 years. He approaches business problems like chess challenges, drawing from his expertise as a chess master. Outside of work, Anshu enjoys playing carrom and tennis, balancing his strategic mind with fun and competition.",
    linkedIn: "https://www.linkedin.com/in/anshum4n/",
  },
  {
    image: harshit,
    name: "Harshit Singhal",
    about:
      "Harshit loves business and has supercharged the growth trajectory for HashedIn, significantly expanding the mid-market segment for Deloitte. Previously, he co-founded Auctus Advisors, a strategy consulting firm acquired by YCP, and worked as a management consultant with SDG. Passionate about history, Harshit also enjoys diving deep into the past to draw lessons for the future.",
    linkedIn: "https://www.linkedin.com/in/harshitsinghal01/",
  },
  {
    image: himanshu,
    name: "Himanshu Varshney",
    about:
      "Himanshu is a people person. Along with leading HashedIn, he has championed the creation of an open culture at Deloitte Engineering and was recognized as one of India's Top 25 Trusted Leaders by GPTW. Formerly with Trilogy, Himanshu is also an All-Star sportsman from IIT Guwahati and HashedIn. He remains active in various sports, continually fostering teamwork and spirit.",
    linkedIn: "https://www.linkedin.com/in/himanshuhv/",
  },
  {
    image: sri,
    name: "Sripathi Krishnan",
    about:
      "Sri is a tech guy who served as the CTO and MD of Modern Software Engineering at Deloitte US, where he was responsible for technology strategy and GenAI innovation. He previously founded RDBTools, acquired by RedisLabs. Known as a champ for GenAI CoE, Sri is also loves hosting and attending parties, blending his passion for technology with a zest for life.",
    linkedIn: "https://www.linkedin.com/in/sripathikrishnan/",
  },
];

export default function LeadersSection() {
  const [flippedCard, setFlippedCard] = useState(null);

  return (
    <div
      style={{ backgroundColor: "rgba(19, 46, 101, 0.10)" }}
      className=" md:py-16 w-full flex justify-center"
    >
      <section className="max-w-[1440px] md:px-[120px] px-[20px] w-full flex flex-col items-center mt-8 md:mt-0">
        <div className="w-full flex justify-start ">
          <img src={tag} alt="tag" />
        </div>
        <h2 className="text-4xl font-bold mb-2 font-montserrat md:text-[40px] text-[24px] text-start w-full ">
          <span
            className="bg-clip-text text-transparent"
            style={{
              backgroundImage:
                "linear-gradient(90deg, #00152E 0%, #003366 100%)",
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
            }}
          >
            Meet Our
          </span>{" "}
          <span
            className="bg-clip-text text-transparent"
            style={{
              backgroundImage:
                "linear-gradient(90deg, #003366 0%, #0066CC 100%)",
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
            }}
          >
            Leaders
          </span>
        </h2>

        <p className="text-gray-600 md:mb-12 font-montserrat text-[16px] md:text-[24px] text-start w-full">
          Experience in innovation
        </p>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-x-6 gap-y-12 md:gap-y-8 w-full mt-8 md:mt-0">
          {leadersData.map((leader, idx) => {
            const isFlipped = flippedCard === idx;

            return (
              <div
                key={idx}
                className="flex flex-col gap-[20px] md:gap-[24px] w-[282px] sm:w-[240px] lg:w-[190px] xl:w-[282px] mx-auto"
              >
                <div className="relative bg-[#044896] w-[282px] h-[282px] xl:w-[282px] xl:h-[282px] sm:w-[240px] sm:h-[240px] lg:w-[190px] lg:h-[190px] rounded-2xl group mx-auto">
                  {/* Image shown by default */}
                  <div className="absolute w-full h-full bottom-[7px]">
                    <img
                      src={leader.image}
                      alt={leader.name}
                      className={`max-w-max mx-auto h-full scale-105 transition-opacity duration-500 ${
                        isFlipped ? "opacity-0" : "group-hover:opacity-0"
                      }`}
                    />
                    <button
                      onClick={() =>
                        setFlippedCard((prev) => (prev === idx ? null : idx))
                      }
                      className="absolute z-[10] bottom-0 right-2 flex lg:hidden w-[32px] h-[32px] p-2 flex-col justify-center items-center gap-2 rounded-[24px] border-[#BBD3F8] border-[1.5px] bg-white shadow-[inset_1px_3px_3px_rgba(0,0,0,0.25),_0px_3px_3px_rgba(0,0,0,0.25)]"
                    >
                      <img
                        src={arrow}
                        alt="arrow-up"
                        className={`${isFlipped ? "rotate-180" : ""}`}
                      />{" "}
                    </button>
                  </div>

                  {/* Text shown on hover or toggle */}
                  <div
                    className={`text-left absolute inset-0 flex justify-center text-white p-[10px] font-roboto font-light text-[16px] sm:text-[13px] lg:text-[16px] transition-opacity duration-500 ${
                      isFlipped
                        ? "opacity-100"
                        : "opacity-0 group-hover:opacity-100"
                    }`}
                  >
                    {leader.about}
                  </div>
                </div>

                <div className="flex justify-between items-center px-2">
                  <p className="font-montserrat font-semibold ">
                    {leader.name}
                  </p>
                  <a
                    href={leader.linkedIn}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="w-[36px] h-[36px] rounded-[8px] p-[6px] bg-[#044896] flex items-center justify-center"
                  >
                    <img
                      src={linkedInIcon}
                      alt="linkedIn"
                      className="w-[22px] h-[22px] invert-100"
                    />
                  </a>
                </div>
              </div>
            );
          })}
        </div>

        <div className="mt-16 w-full">
          <Boot41Banner
            text="Join Our Team"
            btntext="Apply Now"
            to={"/careers2#jobs"}
          />
        </div>
      </section>
    </div>
  );
}
